var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cancel",
    "data-name": "Cancel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      #cancel path {\r\n        stroke-width: 0px;\r\n        fill: currentColor;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.22,22.48c-.19,0-.39-.06-.56-.17-.46-.31-.57-.93-.26-1.39,5.17-7.57,15.43-14.03,15.86-14.3.47-.29,1.09-.15,1.38.32.29.47.15,1.08-.32,1.38-.1.06-10.34,6.52-15.27,13.74-.19.28-.51.44-.83.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.19,22.13c-.35,0-.69-.18-.87-.51-.05-.09-5.21-9.21-14-14.23-.48-.27-.65-.88-.37-1.36s.89-.65,1.36-.37c9.28,5.3,14.54,14.6,14.75,15,.27.48.1,1.09-.39,1.36-.15.09-.32.13-.49.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.8bcfcde50e894f1fa2e43bc4db39649c.svg";
export { ForwardRef as ReactComponent };